import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Etapa 1": { initFrame:  0 },
    "Etapa 2": { initFrame:  0 },
    "Etapa 3": { initFrame:  0 },
    "Portería": { initFrame:  0 },

    //"EveryTransition": { importTransition: AllTransitions }
}
